import { PRICING_STRATEGY } from '@schuettflix/interfaces';

export function derivePricingStrategy(
    isSalesTransportIncluded: boolean,
    isPurchaseTransportIncluded: boolean
): PRICING_STRATEGY {
    if (isPurchaseTransportIncluded) {
        return 'MERCHANT';
    }

    if (isSalesTransportIncluded) {
        return 'FRANCO';
    }

    return 'STANDARD';
}
